import {Component, OnDestroy, OnInit} from '@angular/core';
import moment from 'moment';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {BrandService, MemberService} from '../../services';

@Component({
    selector: 'prism-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
    currentTimestamp = moment().valueOf();
    private subDestroyer$ = new Subject<void>();

    constructor(private memberService: MemberService,
                private brandService: BrandService) {
    }

    ngOnInit(): void {
        // Drives the brand app-wide: styles.scss and the brand kit's tokens.css
        // key all brand colours off data-brand on <html> (see --brand-primary).
        this.brandService.brand$
            .pipe(takeUntil(this.subDestroyer$))
            .subscribe(brand => this.brandService.apply(brand));
    }

    ngOnDestroy(): void {
        this.subDestroyer$.next();
    }
}
